import { replaceAll } from '../helpers/common.js'

export const NORDIC_CURRENCIES = ['DKK', 'NOK']
export const isSEKCurrency = currency => currency === 'SEK'
export const isFinlandCulture = culture =>
  replaceAll(culture, '_', '-').toLowerCase() === 'fi-fi'
export const isEURCurrency = currency => currency === 'EUR'

export const isNlCulture = culture =>
  replaceAll(culture, '_', '-').toLowerCase() === 'nl-nl' ||
  replaceAll(culture, '_', '-').toLowerCase() === 'nl-be'
